import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { generateSSOCode, getProfileData } from '../services/api';
import Avatar from './Avatar';
import idbanner from '../assets/id.png';
import Login from './Login'; // Импортируем сам компонент логина
import '../App.css';

export default function SSORedirect() {
  const [searchParams] = useSearchParams();
  const tempToken = searchParams.get('temp_token');
  const [currentUser, setCurrentUser] = useState(null);
  const [view, setView] = useState('loading'); // 'loading', 'picker', 'login'
  const returnUrl = searchParams.get('return_url');
  document.title = "HATCHUP ID";

  const processingRef = useRef(false);
  // Функция завершения SSO (отправка кода на внешний сайт)
  const finalizeSSO = useCallback(async (tokenForSSO) => {
    if (processingRef.current) return;
    processingRef.current = true;

    setStatus('Авторизация в сервисе...');
    try {
      // Передаем токен явно в функцию
      const res = await generateSSOCode(tokenForSSO);
      const code = res.data.code;

      const separator = returnUrl.includes('?') ? '&' : '?';
      window.location.href = `${returnUrl}${separator}code=${code}`;
    } catch (e) {
      console.error(e);
      alert('Ошибка SSO: ' + (e.response?.data?.error || e.message));
      processingRef.current = false;
      setView('picker');
    }
  }, [returnUrl]);

  const [status, setStatus] = useState('Проверка сессии...');

  useEffect(() => {
    if (!returnUrl) return;

    // ПРИОРИТЕТ 1: Временный токен из URL (после входа через Discord)
    if (tempToken) {
      console.log('SSO: Обнаружен временный токен в URL');
      finalizeSSO(tempToken);
      return;
    }

    // ПРИОРИТЕТ 2: Проверка основной сессии сайта
    const checkSession = async () => {
      const token = localStorage.getItem('hatchup_token');
      if (token) {
        try {
          const res = await getProfileData();
          setCurrentUser(res.data.user);
          setView('picker');
        } catch (e) {
          localStorage.removeItem('hatchup_token');
          setView('login');
        }
      } else {
        setView('login');
      }
    };
    checkSession();
  }, [returnUrl, tempToken, finalizeSSO]);

  if (view === 'loading') return <div className="screen-loader">Проверка...</div>;

  if (view === 'login') {
    return (
      <div className="sso-login-container">
        <div className="sso-badge">Вход в сторонний сервис</div>
        {/* Рендерим компонент Login в режиме SSO */}
        <Login isSSOMode={true} onSSOSuccess={(token) => finalizeSSO(token)} />
        {localStorage.getItem('hatchup_token') && (
          <button className="transfer-button" onClick={() => setView('picker')}>
            Назад к выбору аккаунта
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="login-container sso-picker">
      <div class="banner-container">
        <img src={idbanner} alt="HATCHUP ID" className="login-banner" />
      </div>
      <p className="subtitle">Сервис <b>{new URL(returnUrl).hostname}</b> запрашивает доступ к вашему профилю</p>

      {currentUser && (
        <div className="account-card" onClick={() => finalizeSSO(localStorage.getItem('hatchup_token'))}>
          <Avatar user={currentUser} className="avatar" size="md" />
          <div className="account-info">
            <span className="account-name">{currentUser.serverNickname || currentUser.username}</span>
            <span className="account-action">Продолжить как...</span>
          </div>
          <span className="arrow-icon">➔</span>
        </div>
      )}

      <button className="switch-account-btn" onClick={() => setView('login')}>
        Войти в другой аккаунт
      </button>
    </div>
  );
}